import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { Subscription } from 'rxjs';

import { LoaderTheme, ModalButtons, NotificationTheme } from '@fcom/ui-components';
import { unsubscribe } from '@fcom/core/utils';

import { ProfileService } from '../../services/profile.service';
import { PaymentCardData } from '../../interfaces/payment-cards.interface';

enum CardsStatus {
  INITIAL,
  LOADING,
  COMPLETE,
  ERROR,
}

@Component({
  selector: 'fin-loyalty-payment-cards',
  templateUrl: 'loyalty-payment-cards.component.html',
  styleUrls: ['./loyalty-payment-cards.component.scss'],
  standalone: false,
})
export class LoyaltyPaymentCardsComponent implements OnInit, OnDestroy {
  public readonly CardsStatus = CardsStatus;
  public readonly ModalButtons = ModalButtons;
  public readonly IconLibrary = IconLibrary;
  public readonly NotificationTheme = NotificationTheme;
  public readonly LoaderTheme = LoaderTheme;
  public readonly SvgLibraryIcon = SvgLibraryIcon;

  notification: ElementRef;
  selectedToken: string;
  selectedId: number;
  modalOpen = false;

  private subscriptions = new Subscription();

  @ViewChild('fcomNotification', { static: false })
  set notificationElem(notificationElem: ElementRef) {
    this.notification = notificationElem;
  }

  @ViewChild('cardsHeading', { static: false })
  cardsHeading: ElementRef;

  status: CardsStatus = CardsStatus.INITIAL;
  cardTokens: PaymentCardData[] = [];

  constructor(
    private profileService: ProfileService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getPaymentCards();
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }

  onOpenModal(event: MouseEvent, token: string, id: number): void {
    event.stopPropagation();
    this.selectedToken = token;
    this.selectedId = id;
    this.modalOpen = true;
  }

  onRemoveCard(token: string, id: number): void {
    this.status = CardsStatus.LOADING;
    this.modalOpen = false;
    this.selectedToken = undefined;
    this.selectedId = undefined;
    this.subscriptions.add(
      this.profileService.deletePaymentCard(token).subscribe({
        next: (result) => {
          if (result.ok) {
            this.cardTokens.splice(id, 1);
            this.cardsHeading.nativeElement.focus();
            this.status = CardsStatus.COMPLETE;
          } else {
            this.status = CardsStatus.ERROR;
          }
        },
        error: () => {
          this.status = CardsStatus.ERROR;
        },
        complete: () => {
          this.cdRef.detectChanges();
          this.notification.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
      })
    );
  }

  private getPaymentCards() {
    this.status = CardsStatus.LOADING;
    this.subscriptions.add(
      this.profileService.getParsedPaymentCards().subscribe({
        next: (cards) => {
          if (cards) {
            this.cardTokens = cards;
          }
          this.status = CardsStatus.INITIAL;
        },
        error: () => {
          this.status = CardsStatus.INITIAL;
        },
      })
    );
  }
}
